// client/src/services/api.js
import axios from 'axios';
import { API_BASE_URL } from '../config';

const API_URL = API_BASE_URL;


const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor to include the auth token
api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth API
export const authAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  register: (email, password, name) => api.post('/auth/register', { email, password, name }),
  getCurrentUser: () => api.get('/auth/me'),
};

// Patient API
export const patientAPI = {
  getAll: () => api.get('/patients'),
  getById: (id) => api.get(`/patients/${id}`),
  create: (data) => api.post('/patients', data),
  update: (id, data) => api.put(`/patients/${id}`, data),
  delete: (id) => api.delete(`/patients/${id}`),
  checkDuplicates: (params) => api.get('/patients/check-duplicates', { params }),
};

// Medical History API
export const medHistoryAPI = {
  getByPatientId: (patientId) => api.get(`/medical-history/patient/${patientId}`),
  create: (data) => api.post('/medical-history', data),
  update: (id, data) => api.put(`/medical-history/${id}`, data),
  delete: (id) => api.delete(`/medical-history/${id}`),
};

// Medications API
export const medicationAPI = {
  getByPatientId: (patientId) => api.get(`/medications/patient/${patientId}`),
  create: (data) => api.post('/medications', data),
  update: (id, data) => api.put(`/medications/${id}`, data),
  delete: (id) => api.delete(`/medications/${id}`),
};

// Operations API
export const operationAPI = {
  getByPatientId: (patientId) => api.get(`/operations/patient/${patientId}`),
  create: (data) => api.post('/operations', data),
  update: (id, data) => api.put(`/operations/${id}`, data),
  delete: (id) => api.delete(`/operations/${id}`),
};

// Patient Files API
export const patientFileAPI = {
  getByPatientId: (patientId) => api.get(`/patient-files/patient/${patientId}`),
  upload: (patientId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/patient-files/${patientId}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  delete: (id) => api.delete(`/patient-files/${id}`),
};

// System API
export const systemAPI = {
  openFolder: (folderPath) => api.post('/system/open-folder', { folderPath }),
  getEpembaseis: () => api.get('/system/epembaseis'),
  createDiagnosis: (epembasi) => api.post('/system/epembaseis', { epembasi }),
  updateDiagnosis: (id, epembasi) => api.put(`/system/epembaseis/${id}`, { epembasi }),
  deleteDiagnosis: (id) => api.delete(`/system/epembaseis/${id}`),
};

export default api;